module.exports = __webpack_public_path__ + "static/media/combell@2x.f0a4da58.png";